import { render } from "./CardElement.vue?vue&type=template&id=a19aa2a4&scoped=true"
import script from "./CardElement.vue?vue&type=script&lang=js"
export * from "./CardElement.vue?vue&type=script&lang=js"

import "./CardElement.vue?vue&type=style&index=0&id=a19aa2a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19aa2a4"]])

export default __exports__